import Calendar from './Calendar';

export default Calendar;



// WEBPACK FOOTER //
// ./src/index.js